import styles from './WellcomePage.module.scss'
import { Link, useNavigate } from "react-router-dom"
import {useIsAuth} from '../../hooks/auth'
import useHasRate from "../../hooks/useHasRate"
import { useCallback, useEffect, useRef, useState } from "react"
import { AUTH_URL, RATES_URL, SOURCES, VACANCIES_URL } from "../../utils/consts"
import { Grid } from '@mui/material'
import Layout from '../../ui/Layout/Layout'
import SourceName from '../../components/SourceName/SourceName'
import { IPosition } from '../../hooks/common/useRandomPosition'
import Button from '../../ui/Button/Button'


const WellcomePage = () => {
  const navigate = useNavigate()
  const {data: isAuth} = useIsAuth()

  const sourceWrapRef = useRef<HTMLDivElement>(null)
  const getParent = useCallback(() => {
    return sourceWrapRef.current
  }, [sourceWrapRef])
  const [positions, setPositions] = useState<Record<string, IPosition>>({})

  useEffect(() => {
    const cb = () => setPositions({})
    window.addEventListener('resize', cb)

    return () => {
      window.removeEventListener('resize', cb)
    }
  }, [])

  return (
    <div className={styles.root}>
      <h1 className={styles.h}>JobMagazine - бесплатный сервис для поиска свежих вакансий. Подробности ниже!</h1>

      <div className={styles.introContainer}>
        <Layout className={styles.layout} kind={'white'}>
          <h2>Вакансии с различных источников в одном месте</h2>
        </Layout>
        <Layout className={styles.layout} kind={'white'}>
          <h2>Удобные и эффективные фильтры</h2>
        </Layout>
        <Layout className={styles.layout} kind={'white'}>
          <h2>Уведомления в telegram</h2>
        </Layout>
      </div>

      <div className={styles.navigateBtns}>
        <Button
          className={styles.toVacancies}
          onClick={() => {navigate(VACANCIES_URL)}}
          kind='black'
        >
          <h3>Вакансии</h3>
        </Button>

        <Button
          className={styles.toTg}
          onClick={() => {window.open("https://t.me/JobMagazineBot", "_blank")}}
          kind='black'
        >
          <h3>Telegram bot</h3>
        </Button>
      </div>

      <div className={styles.sourcesWrap} ref={sourceWrapRef}>
        {SOURCES.map(source => (
          <SourceName
            key={source.id}
            name={source.name}
            url={source.url}
            sourceId={source.localId || source.id}
            getParent={getParent}
            positions={positions}
            setPositions={setPositions}
          />
        ))}
      </div>
      <Layout className={styles.about} kind={'white'}>
        <h2>Как это работает?</h2>
        <ul>
          <li><h3>Заведите аккаунт.</h3></li>
          {/* <li><h3>Выберите тариф или пробный период на 3 дня</h3></li> */}
          <li><h3>Настройте фильтры для подбора вакансий.</h3></li>
          <li><h3>Новые вакансии добавляются каждый час или чаще.</h3></li>
          <li><h3>Вакансии удаляются спустя неделю после их публикации. Успейте откликнуться!</h3></li>
          <li><h3>Новые вакансии избранных компаний можно получать в телеграме - подключите нашего <Link to="https://t.me/JobMagazineBot" target='_blank'>бота</Link>!</h3></li>
        </ul>
      </Layout>
    </div>
  )
}

export default WellcomePage